module.exports = __webpack_public_path__ + "static/media/background.21645ba0.png";